import React from 'react';
import { Link } from 'react-router-dom';

function formatDate(value) {
  if (!value) return 'the scheduled retention deadline';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'the scheduled retention deadline';
  return new Intl.DateTimeFormat(undefined, {dateStyle: 'long'}).format(date);
}

export default function WorkspaceAccessEnded({lifecycle = {}}) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10">
      <section className="w-full max-w-xl rounded-3xl border border-slate-200 bg-white p-7 shadow-sm sm:p-10">
        <img src="/AffinityAI_Logo_Gradient@2x.png" alt="AffinityAI" className="h-10 w-auto" />
        <p className="mt-8 text-xs font-semibold uppercase tracking-[0.18em] text-amber-700">Workspace access ended</p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">Your workspace is safely retained</h1>
        <p className="mt-4 leading-7 text-slate-700">
          This workspace is no longer accessible because its trial or paid access ended. Project and participant content is not available in read-only form.
        </p>
        <p className="mt-3 leading-7 text-slate-700">
          An authorized workspace administrator can recover it by starting a paid subscription before {formatDate(lifecycle.scheduledDeletionAt)}. Signing in or opening an invitation does not reactivate access.
        </p>
        <div className="mt-7 flex flex-wrap gap-3">
          <Link to="/pricing" className="rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 focus-visible:ring-offset-2">
            Review subscription options
          </Link>
          <a href="mailto:customers@affinityai.app" className="rounded-full border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-800">
            Contact customer support
          </a>
        </div>
      </section>
    </main>
  );
}
